import { TENANT_PLATFORM } from '@hiver/bifrost-js';
import { ReactComponent as GmailIcon }  from "../../images/GmailIcon.svg";
import { ReactComponent as OutlookIcon } from "../../images/OutlookIcon.svg";
import { ReactComponent as OtherLoginIcon } from "../../images/OtherLoginIcon.svg";

export const EMAIL_PLACEHOLDER = 'Enter your Hiver email';
export const PASSWORD_PLACEHOLDER = 'Enter your password';
export const LOG_IN_DESCRIPTION = 'Log in to access your Help center';
export const LOG_IN = 'Log In';
export const CONTINUE = 'Continue';
export const OTP_SCREEN_BUTTON_LABEL = 'Login';
export const OTP_LABEL = 'Enter verification code';
export const WELCOME = 'Welcome!';
export const DIFF_EMAIL_ERROR = 'Please login using the same Google account';
export const NO_ACCESS_ERROR = 'You don’t have access to this section, please contact your administrator';
export const DEFAULT_LOGO = 'default';
export const LOGO_IMG = 'https://app.hiverkb.com/{{LOGO}}';
export const selectEmailProviderText = 'Select your email provider';
export const selectProductText = 'Select the product you want to access';
export const gmail = 'Gmail';
export const outlook = 'Outlook';
export const other = 'Other';
export const emailLabel = 'Enter your email address';
export const passwordLabel = 'Enter your password';
export const EMAIL_PROVIDER_OTHER = 'other';
export const hiverOmni = 'Hiver Omni';
export const hig = 'HIG (Hiver in Gmail)';

export const PRODUCT_TYPE = {
    OMNI: 'omni',
    HIG: 'hig'
};

export const AUTH_PROVIDER = {
    GOOGLE: 'google',
    MICROSOFT: 'microsoft'
};

export const EMAIL_SELECTOR_PROVIDERS = [
    {
        NAME: gmail,
        TENANT_ID: TENANT_PLATFORM.GMAIL,
        ICON: GmailIcon,
        IMG_ALT: gmail
    },
    {
        NAME: outlook,
        TENANT_ID: TENANT_PLATFORM.HIVERWEB,
        ICON: OutlookIcon,
        IMG_ALT: outlook
    },
    {
        NAME: other,
        TENANT_ID: EMAIL_PROVIDER_OTHER,
        ICON: OtherLoginIcon,
        IMG_ALT: other
    }
];

export const PRODUCT_OPTIONS = [
    {
        ID: PRODUCT_TYPE.OMNI,
        NAME: hiverOmni,
        VALUE: PRODUCT_TYPE.OMNI
    },
    {
        ID: PRODUCT_TYPE.HIG,
        NAME: hig,
        VALUE: PRODUCT_TYPE.HIG
    }
];

// ── New wizard login constants ──
export const WIZARD_STEPS = {
    EMAIL: 'email',
    PRODUCT: 'product',
    SIGN_IN: 'signIn',
};

export const welcomeTitle = 'Welcome!';
export const welcomeSubtitle = 'Log in to access your Help center';
export const workEmailLabel = 'Work email';
export const emailInputPlaceholder = 'e.g. name@acme.com';
export const continueButtonText = 'Continue';
export const chooseProductTitle = 'Choose a product';
export const chooseProductSubtitle = 'Your account has access to both products.';
export const omniProductDesc = 'Multi-channel customer support platform';
export const higProductDesc = 'Hiver inside Gmail — inbox collaboration';
export const signIntoOmniTitle = 'Sign into Omni';
export const googleRedirectSubtitle = "Your account uses Google sign-in. We'll redirect you to Google to authenticate.";
export const signInWithGoogleText = 'Sign in with Google';
export const signInWithMicrosoftText = 'Sign in with Microsoft';
export const orDividerText = 'OR';
export const enterPasswordLabel = 'Enter Password';
export const enterPasswordPlaceholder = 'Enter Password';
export const logInButtonText = 'Log In';
